import { aboutStats, principles, testimonials, siteSlogan, disclaimText } from '@/mocks/gossip';
import SectionHead from './SectionHead';

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-28 py-12 md:py-16 bg-background-50">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          kicker="ABOUT US"
          kickerZh="关于与投稿"
          title="把每一口瓜，都吃出道理"
          desc="吃瓜热点由一群爱较真的内容编辑维护。我们不满足于搬运热搜标题，而是坚持把一个热点背后的来龙去脉、相关方与逻辑讲完整。"
          action={
            <a
              href="mailto:hello@chigua-hotspot.example.com"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line"></i>
              投稿 / 联系我们
            </a>
          }
        />

        {/* stats */}
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {aboutStats.map((s) => (
            <div key={s.label} className="rounded-xl border border-accent-200/70 bg-accent-100/40 px-4 py-6 text-center">
              <p className="font-heading text-2xl md:text-4xl font-black text-accent-700">{s.num}</p>
              <p className="mt-2 text-xs md:text-sm text-accent-900/80">{s.label}</p>
            </div>
          ))}
        </div>

        {/* principles + testimonials */}
        <div className="mt-8 grid gap-5 lg:grid-cols-2">
          <div className="flex flex-col gap-4">
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              <i className="ri-sparkling-2-line mr-2 text-primary-500"></i>
              我们坚持的三条原则
            </h3>
            {principles.map((p) => (
              <div key={p.title} className="flex gap-4 rounded-xl border border-background-200 bg-background-100/50 p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <div>
                  <h4 className="font-heading text-base font-bold text-foreground-950">{p.title}</h4>
                  <p className="mt-1.5 text-sm leading-6 text-foreground-600">{p.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-heading text-lg font-bold text-foreground-950">
              <i className="ri-chat-quote-line mr-2 text-accent-600"></i>
              追瓜读者怎么说
            </h3>
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-xl border border-background-200 bg-background-100/50 p-5">
                <div className="flex gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-7 text-foreground-700">“{t.text}”</blockquote>
                <figcaption className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                  <span className="font-semibold text-foreground-700">{t.name}</span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-secondary-700 whitespace-nowrap">{t.tag}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        {/* tagline banner */}
        <div className="mt-8 overflow-hidden rounded-xl border border-background-200 bg-gradient-to-r from-primary-100/70 via-accent-100/60 to-background-100 p-6 md:p-8">
          <p className="font-brand text-xl md:text-3xl text-primary-800">
            “{siteSlogan}，把瓜吃透吃全。”
          </p>
          <p className="mt-3 max-w-3xl text-xs md:text-sm leading-6 text-foreground-600">
            {disclaimText}
          </p>
        </div>
      </div>
    </section>
  );
}